<template>
  <div class="amendments-container">
    <h1 style="margin-left: 20px;">Bonus (abgelaufen)</h1>
    <div class="con mt-4" style="margin-left: 10px;">
      <!-- Suche -->
      <vs-row class="mt-3">
        <vs-input
          class="search-input org-width"
          icon-after
          placeholder="Suche nach Überschrift"
          v-model="searchTitle"
          icon="search"
        />
        <vs-input
          type="date"
          class="ml-3"
          icon="search"
          icon-after
          v-model="searchExpireDate"
        />
      </vs-row>

      <div class="outer-con2">
        <!-- Tabelle -->
        <div class="table-container mt-4">
          <table>
            <thead>
              <tr>
                <th @click="sort('headline_text')">
                  Überschrift
                  <div
                    class="arrow"
                    v-if="currentSort === 'headline_text'"
                    :class="ascending ? 'arrow_up' : 'arrow_down'"
                  ></div>
                </th>
                <th @click="sort('discount_text')">
                  Angebot
                  <div
                    class="arrow"
                    v-if="currentSort === 'discount_text'"
                    :class="ascending ? 'arrow_up' : 'arrow_down'"
                  ></div>
                </th>
                <th @click="sort('end_at')">
                  Gültig bis
                  <div
                    class="arrow"
                    v-if="currentSort === 'end_at'"
                    :class="ascending ? 'arrow_up' : 'arrow_down'"
                  ></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="bonus in filteredBonuses"
                :key="bonus.id"
                class="cursor-pointer"
                @click="openBonusDetail(bonus)"
              >
                <td>{{ bonus.headline_text }}</td>
                <td>{{ bonus.discount_text }}</td>
                <td>{{ bonus.end_at | formatDate }}</td>
              </tr>
              <tr v-if="filteredBonuses.length === 0">
                <td colspan="3" style="text-align:center; color: grey;">
                  Keine abgelaufenen Boni gefunden
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Bonus Detail Popup -->
    <BonusDetailPopup
      v-if="showPopup"
      :bonus="selectedBonus"
      :showPopup.sync="showPopup"
      @close="closePopup"
    />
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import BonusDetailPopup from "@/components/bonus/BonusDetailPopup.vue";

export default Vue.extend({
  name: "ExpiredBonus",
  components: { BonusDetailPopup },

  async mounted() {
    await this.$store.dispatch("bonus/loadBonuses");
  },

  data() {
    return {
      searchTitle: "",
      searchExpireDate: "",
      ascending: true,
      currentSort: "end_at",
      showPopup: false,
      selectedBonus: null,
    };
  },

  computed: {
    bonuses() {
      const bonuses = this.$store.getters["bonus/getBonuses"] || [];
      const now = moment();
      return bonuses.filter(
        (bonus) =>
          moment(bonus.end_at).isBefore(now) && bonus.status === "active"
      );
    },

    filteredBonuses() {
      let result = [...this.bonuses];

      if (this.searchTitle) {
        result = result.filter((bonus) =>
          bonus.headline_text
            .toLowerCase()
            .includes(this.searchTitle.toLowerCase())
        );
      }

      if (this.searchExpireDate) {
        result = result.filter((bonus) =>
          bonus.end_at.includes(this.searchExpireDate)
        );
      }

      result.sort((a, b) => {
        let modifier = this.ascending ? 1 : -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });

      return result;
    },
  },
  watch: {
    searchTitle() {
      this.closePopup();
    },
  },

  methods: {
    sort(column) {
      if (this.currentSort === column) {
        this.ascending = !this.ascending;
      } else {
        this.currentSort = column;
        this.ascending = true;
      }
    },

    openBonusDetail(bonus) {
      this.selectedBonus = bonus;
      this.showPopup = true;
    },

    closePopup() {
      this.showPopup = false;
      this.selectedBonus = null;
    },
  },

  filters: {
    formatDate(value) {
      if (!value) return "";
      return moment(value).format("DD.MM.YYYY");
    },
  },
});
</script>

<style scoped>
/* Tabelle */
.table-container table {
  width: 100%;
  border-collapse: collapse;
}
.table-container th,
.table-container td {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}
.cursor-pointer {
  cursor: pointer;
}
.arrow {
  width: 12px;
  height: 15px;
  display: inline-block;
  margin-left: 5px;
  background-size: contain;
  background-repeat: no-repeat;
}
.arrow_up {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAaCAYAAACgoey0AAAAAXNSR0IArs4c6QAAAwpJREFUSA21Vt1PUmEYP4dvkQ8JFMwtBRocWAkDbiqXrUWXzU1rrTt0bdVqXbb1tbW16C9IBUSmm27cODdneoXjputa6069qwuW6IIBIdLvdaF4OAcOiGeDc87zPs/vd57P96WpFq7p6enbGo1mjKZpeTabjU1MTCRagGnOZHFxcXxtbe1XKpUq7+zslJeXl//Mz8+Hy+Uy3RxSE9qTk5M3otFooVQqgef4Wl9f343FYoEmoISrxuNxFX5f9vb2jhn/PxUKhfLS0tIPfFifUESRUMV8Pv/M6XReRm5rTGQyGeXxeGxYe1ezeBpBOBx2rKysbO7v79d4Wy3Y2Nj4GQqFbgnhaugxwiuGJx99Pp9FLBbXxYTXvTqd7v3MzIy6riIWGxJnMpl7AwMD14xGYyMsSq1WUyQdUqn0eSPlusQIsbGrq+vl4OCgvhFQZd1utyv1en0gEolcqsi47nWJlUrlG5fLZVcoFFy2nDKSDpIWlUoVTCQSEk4lCHmJMZ2GTCbTiMVikfIZ88l7enoos9l8dXt7+z6fDicxSJUokqDX6xXcl2wCROoc0vQCWL3sNfLOSdzR0fHY4XC4tVotl40gmVwup9xuN4OQv+UyqCFGH9rg7SOGYVRcBs3IEG4J0nVnamrqOtvuBDGGgQg9+wHFcVEi4a0LNkbdd6TrPKo8ODc311mteIIYjT/a398/jK+s1jnVM0kXoufCFvq0GuiIGEVgQIhfoygM1QrteEa9dAL7ITiYCt4RMabOK5AyKKzKWtvupLcRciu8D5J0EuDDPyT/Snd39yh6VtY2NhYQSR9G79Ds7OxdskRjEyAufvb7/cPoO5Z6e1+xtVKrq6vfcFzyi/A3ZrPZ3GdNSlwgo5ekE4X2RIQGf2C1WlufFE0GBeGWYQ8YERWLxQtnUVB830MKLZfL9RHir8lkssCn2G751tZWEWe03zTKm15YWPiEiXXTYDB0Ig/t7yd8PRws4EicwWHxO4jHD8/C5HiTTqd1BwcHFozKU89origB+y/kmzgYpgOBQP4fGmUiZmJ+WNgAAAAASUVORK5CYII=");
}
.arrow_down {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAaCAYAAABPY4eKAAAAAXNSR0IArs4c6QAAAvlJREFUSA29Vk1PGlEUHQaiiewslpUJiyYs2yb9AyRuJGm7c0VJoFXSX9A0sSZN04ULF12YEBQDhMCuSZOm1FhTiLY2Rky0QPlQBLRUsICoIN/0PCsGyox26NC3eTNn3r3n3TvnvvsE1PkwGo3yUqkkEQqFgw2Mz7lWqwng7ztN06mxsTEv8U0Aam5u7r5EInkplUol/f391wAJCc7nEAgE9Uwmkzo4OPiJMa1Wq6cFs7Ozt0H6RqlUDmJXfPIx+qrX69Ti4mIyHA5r6Wq1egND+j+IyW6QAUoul18XiUTDNHaSyGazKcZtdgk8wqhUKh9o/OMvsVgsfHJy0iWqVrcQNRUMBnd6enqc9MjISAmRP3e73T9al3XnbWNjIw2+KY1Gc3imsNHR0YV4PP5+d3e32h3K316TySQFoX2WyWR2glzIO5fLTSD6IElLNwbqnFpbWyO/96lCoai0cZjN5kfYQAYi5H34fL6cxWIZbya9iJyAhULBHAqFVlMpfsV/fHxMeb3er+Vy+VUzeduzwWC45XA4dlD/vEXvdDrj8DvURsYEWK3WF4FA4JQP9mg0WrHZbEYmnpa0NxYgPVObm5teiLABdTQT8a6vrwdRWhOcHMzMzCiXlpb2/yV6qDttMpkeshEzRk4Wo/bfoe4X9vb2amzGl+HoXNT29vZqsVi0sK1jJScG+Xx+HGkL4Tew2TPi5zUdQQt9otPpuBk3e0TaHmMDh1zS7/f780S0zX6Yni+NnBj09fUZUfvudDrNZN+GkQbl8Xi8RLRtHzsB9Hr9nfn5+SjSeWUCXC7XPq5kw53wsNogjZNohYXL2EljstvtrAL70/mVaW8Y4OidRO1/gwgbUMvcqGmcDc9aPvD1gnTeQ+0nmaInokRj0nHh+uvIiVOtVvt2a2vLv7Ky0tL3cRTXIcpPAwMDpq6R4/JXE4vFQ5FI5CN+QTaRSFCYc8vLy1l0rge4ARe5kJ/d27kYkLXoy2Jo4C7K8CZOsEBvb+9rlUp1xNXPL7v3IDwxvPD6AAAAAElFTkSuQmCC");
}
</style>
